export default "__VITE_ASSET__cRWtHSR2__"